import React from "react";

// SVG neural-network / circuit decorations used across the page.
// Pure SVG so it stays crisp + tiny.

export const NeuralNet = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 800 600"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <radialGradient id="n-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.9" />
        <stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="n-line" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.5" />
        <stop offset="100%" stopColor="#39FF14" stopOpacity="0.35" />
      </linearGradient>
    </defs>
    {/* Lines */}
    {[
      [80, 120, 280, 90],
      [80, 120, 240, 260],
      [280, 90, 480, 180],
      [240, 260, 480, 180],
      [240, 260, 380, 420],
      [480, 180, 660, 100],
      [480, 180, 620, 320],
      [380, 420, 620, 320],
      [620, 320, 720, 480],
      [380, 420, 540, 520],
      [240, 260, 120, 440],
      [120, 440, 380, 420],
    ].map(([x1, y1, x2, y2], i) => (
      <line
        key={i}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke="url(#n-line)"
        strokeWidth="1.2"
        strokeDasharray="3 6"
      />
    ))}
    {/* Nodes */}
    {[
      [80, 120],
      [280, 90],
      [240, 260],
      [480, 180],
      [660, 100],
      [620, 320],
      [380, 420],
      [720, 480],
      [540, 520],
      [120, 440],
    ].map(([cx, cy], i) => (
      <g key={i}>
        <circle cx={cx} cy={cy} r="14" fill="url(#n-glow)" />
        <circle cx={cx} cy={cy} r="3" fill="#39FF14" />
      </g>
    ))}
  </svg>
);

export const CircuitTrace = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g stroke="#00E5FF" strokeOpacity="0.35" strokeWidth="1" fill="none">
      <path d="M0 80 H120 V40 H220 V100 H320 V60 H400" />
      <path d="M0 200 H80 V240 H180 V160 H300 V220 H400" />
      <path d="M0 320 H160 V280 H260 V340 H400" />
    </g>
    <g fill="#39FF14">
      <circle cx="120" cy="80" r="2.5" />
      <circle cx="220" cy="40" r="2.5" />
      <circle cx="320" cy="100" r="2.5" />
      <circle cx="80" cy="200" r="2.5" />
      <circle cx="180" cy="240" r="2.5" />
      <circle cx="300" cy="160" r="2.5" />
      <circle cx="160" cy="320" r="2.5" />
      <circle cx="260" cy="280" r="2.5" />
    </g>
  </svg>
);

export const HexRing = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 500 500"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g
      fill="none"
      stroke="#00E5FF"
      strokeOpacity="0.35"
      strokeDasharray="2 8"
      strokeWidth="1"
    >
      <circle cx="250" cy="250" r="240" />
      <circle cx="250" cy="250" r="190" strokeOpacity="0.22" />
      <circle cx="250" cy="250" r="140" strokeOpacity="0.16" />
    </g>
    <g stroke="#39FF14" strokeOpacity="0.6" strokeWidth="1" fill="none">
      <polygon points="250,30 410,130 410,330 250,430 90,330 90,130" />
    </g>
  </svg>
);
